<script lang="ts">
  // An on/off switch: a button with the switch role, so Space and Enter
  // flip it and a screen reader says "on" or "off". It is named and
  // described by the elements `labelledby` and `describedby` point at, and
  // says its state in words beside the track, not by colour alone.
  interface Props {
    on: boolean;
    labelledby: string;
    describedby?: string;
    /** Nothing can be chosen (the state is not known yet). */
    disabled?: boolean;
    /** The choice is on its way to where it is kept. */
    busy?: boolean;
    onchange: (on: boolean) => void;
  }
  let { on, labelledby, describedby, disabled = false, busy = false, onchange }: Props = $props();
</script>

<button
  type="button"
  class="switch"
  role="switch"
  aria-checked={on}
  aria-labelledby={labelledby}
  aria-describedby={describedby}
  aria-busy={busy ? 'true' : undefined}
  {disabled}
  onclick={() => onchange(!on)}
>
  <span class="track" aria-hidden="true"></span>
  <span class="state" aria-hidden="true">{on ? 'On' : 'Off'}</span>
</button>
